module.exports = __webpack_public_path__ + "static/media/1_BB.473a354e.jpg";